import classnames from 'classnames'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'

import { SimpleButton } from 'ui'

import styles from './index.css'

class CreateBanner extends PureComponent {
  render() {
    const { className, onCreateTournament, prefix } = this.props

    return (
      <div
        className="CreateBanner rounded-lg overflow-hidden m-1 shadow hover:shadow-lg focus:shadow-lg"
        data-dark-mode="true"
      >
        <SimpleButton className={classnames(styles.button, className)} onClick={onCreateTournament}>
          <h3 className={styles.title}>
            {prefix ? (
              <>
                <em>{prefix}, </em> crea tu propio torneo
              </>
            ) : (
              <>
                <em>Crea</em> tu propio torneo
              </>
            )}
          </h3>
        </SimpleButton>
      </div>
    )
  }
}

CreateBanner.propTypes = {
  onCreateTournament: PropTypes.func.isRequired,

  className: PropTypes.string,
  prefix: PropTypes.string,
}

CreateBanner.defaultProps = {
  className: '',
  prefix: '',
}

export default CreateBanner
